import React from 'react';
import { cn } from '../../lib/cn';

type Variant = 'ghost' | 'secondary' | 'danger';
type Size = 'sm' | 'md' | 'lg';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  'aria-label': string;
  variant?: Variant;
  size?: Size;
}

const variants: Record<Variant, string> = {
  ghost: 'bg-transparent text-foreground-muted hover:bg-surface-3 hover:text-foreground',
  secondary: 'bg-surface-3 text-foreground hover:bg-surface-4 border border-border',
  danger: 'bg-transparent text-foreground-muted hover:bg-danger/10 hover:text-danger',
};

const sizes: Record<Size, string> = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-11 w-11',
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, variant = 'ghost', size = 'md', className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center rounded-lg transition-colors duration-150',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 disabled:opacity-50',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {icon}
    </button>
  )
);

IconButton.displayName = 'IconButton';
